import styled from '@emotion/styled';

export const LayoutWrapper = styled.div`
  display: flex;
  gap: 60px;

  /* height: 839px; */
`;
